module.exports = __webpack_public_path__ + "media/images/banner-mobile-edce615d.jpg";